import { checkAuth } from '@libs/localStorage'
import { useQuery } from 'react-query'
import { getReportSaleOrder, TReportSaleOrderParams } from '@src/queries/apis/report-sale-order'

export const REPORT_SALE_ORDER_KEY = ['report','sale-order'] as const

export const useQueryReportSaleOrder = (params?: TReportSaleOrderParams) => {
  const token = checkAuth()
  return useQuery(
    [...REPORT_SALE_ORDER_KEY, params],
    () => getReportSaleOrder(params as TReportSaleOrderParams, token || ''),
    {
      enabled: !!token && !!params?.startDate && !!params?.endDate && Array.isArray(params?.groupBy) && (params!.groupBy!.length > 0),
      keepPreviousData: true,
      staleTime: 5 * 60 * 1000,
    },
  )
}
